// @flow
'use strict';

import { connect } from 'react-redux';

import ModalTipoExportacao from './modal_tipo_exportacao';

export default connect<*, *, *, *, *, *>()(ModalTipoExportacao);
